import { render, staticRenderFns } from "./ProfilePartOne.vue?vue&type=template&id=208a750f&"
import script from "./ProfilePartOne.vue?vue&type=script&lang=js&"
export * from "./ProfilePartOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports